type ImageLoader = {
  src: any;
  width: number;
  quality?: number;
};

export const imageLoader = ({ src, width, quality }: ImageLoader) => {
  return `${src}?w=${width}&q=${quality ?? 75}`;
};
